import React, { useEffect } from "react";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getGreet, getInvitation } from "../../../../Redux/App/action";

const AllCardsCrousel = () => {
  const dispatch = useDispatch();
  const { greetCards, invitationCards } = useSelector(
    (store) => store.appReducer
  );

  useEffect(() => {
    dispatch(getGreet);
    dispatch(getInvitation);
  }, [dispatch]);
  return (
    <Flex gap={4} flexDirection={{ md: "row", base: "column" }}>
      {/* <Box w={{ md: "50%", base: "100%" }} bg={"#e4e4e4"} padding={"1em 2em"}>
        <Text className="oswald-font" fontWeight={"bold"} fontSize={20}>
          Greet Your Loved One's
        </Text>
        <Text
          color={"gray"}
          className="lato-font"
          fontWeight={"regular"}
          fontSize={14}
          mt={-1}
        >
          Your Loved One's
        </Text>
        <Box
          display={"grid"}
          gridTemplateColumns={{
            md: "repeat(3,1fr)",
            base: "repeat(1,1fr)",
          }}
          gap={{ md: 3, base: 2 }}
          padding={"1em 0"}
        >
          {greetCards.slice(0, 6).map((el, i) => (
            <Link key={i} to={`/shareCards/${el.sourceMediaId}`}>
              <Box>
                <Image
                  src={el.imageUrl}
                  onMouseEnter={(event) => {
                    event.target.style.transform = "scale(1.05)";
                    event.target.style.transition = "0.1s ease-in";
                  }}
                  onMouseLeave={(event) => {
                    event.target.style.transform = "scale(1)";
                  }}
                />
                <Text
                  fontSize={{ md: 14, base: 10 }}
                  fontWeight={"semibold"}
                  color={"gray"}
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                >
                  {el.cardName}
                </Text>
              </Box>
            </Link>
          ))}
        </Box>
        <Link
          to={"/GreetingsSubCat"}
          className="text-white bg-[#464957] cursor-pointer px-4 py-2"
        >
          See more
        </Link>
      </Box> */}

      {/* <Box w={{ md: "50%", base: "100%" }} bg={"#e4e4e4"} padding={"1em 2em"}>
        <Text className="oswald-font" fontWeight={"extrabold"} fontSize={20}>
          Invitations
        </Text>
        <Text
          color={"gray"}
          className="lato-font"
          fontWeight={"regular"}
          fontSize={{ md: 14 }}
          mt={-1}
        >
          Customize Your Invitation Card, Start Inviting Family & Friends..
        </Text>
        <Box
          display={"grid"}
          gridTemplateColumns={{
            md: "repeat(3,1fr)",
            base: "repeat(1,1fr)",
          }}
          gap={{ md: 3, base: 2 }}
          padding={"1em 0"}
        >
          {invitationCards
            .filter((card) => card.mediaType === "TEMPLATE_PREVIEW")
            .slice(0, 6)
            .map((card, i) => (
              <Link key={i} to={`/customizeInvitation/${card.sourceMediaId}`}>
                <Box>
                  <>
                    <Image
                      src={card.imageUrl}
                      onMouseEnter={(event) => {
                        event.target.style.transform = "scale(1.05)";
                        event.target.style.transition = "0.1s ease-in";
                      }}
                      onMouseLeave={(event) => {
                        event.target.style.transform = "scale(1)";
                      }}
                    />

                    <Text
                      fontSize={{ md: 14, base: 10 }}
                      fontWeight={"semibold"}
                      color={"gray"}
                      whiteSpace="nowrap"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      {card.cardName}
                    </Text>
                  </>
                </Box>
              </Link>
            ))}
        </Box>
        <Link
          to={"/InvitationSubCat"}
          className="text-white bg-[#464957] cursor-pointer px-4 py-2"
        >
          See more
        </Link>
      </Box> */}
    </Flex>
  );
};

export default AllCardsCrousel;
